import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { updateConsent } from '../../utils/analytics';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookieConsent');
    const dismissed = sessionStorage.getItem('cookieDismissed');
    if (!hasConsented && !dismissed) {
      setIsVisible(true);
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
    try {
      updateConsent(true);
    } catch {}
  };

  const handleDismiss = () => {
    // Hide without setting consent; remember for this session only
    sessionStorage.setItem('cookieDismissed', 'true');
    setIsVisible(false);
  };
  
  if (!isVisible) return null;
  
  return (
    <div id="cookie-consent" className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 md:p-6 z-50" role="region" aria-label="Cookie notice">
      <div className="max-w-7xl mx-auto relative">
        <button
          type="button"
          onClick={handleDismiss}
          aria-label="Dismiss cookie notice"
          className="absolute top-2 right-2 p-2 rounded hover:bg-gray-100 text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pr-10 md:pr-0">
          <div className="flex-1">
            <p className="text-gray-600 text-sm md:text-base">
              We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies. Read our{' '}
              <Link to="/privacy-policy" className="underline hover:text-gray-700">
                Privacy Policy
              </Link>
              {' '}and{' '}
              <Link to="/cookie-policy" className="underline hover:text-gray-700">
                Cookie Policy
              </Link>
              {' '}to learn more.
            </p>
          </div>
          <div className="flex justify-end">
            <Button
              variant="primary"
              size="lg"
              onClick={handleAccept}
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 